module.exports = __webpack_public_path__ + "static/media/ArrowLeft.c4353794.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ArrowLeft.svg
// module id = 1042
// module chunks = 0